module.exports = __webpack_public_path__ + "static/media/bibleminded1.c4645609.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/bibleminded1.png
// module id = 104
// module chunks = 0